import React from "react";
import "../../fonts/FontFaces.css"
import {Link} from "../styled/TextComponents";
import Logo from "../Logo";
import {useNavigate} from "react-router-dom";
import ModalSendMail from "./ModalSendMail";
import { useI18n } from "../../i18n/I18nProvider";

const Header = () =>{
    const { t } = useI18n();
    const navigate = useNavigate();
    const [isModalSendOpen, setIsModalSendOpen] = React.useState(false);

    return(
        <header style={{
            width: "90%",
            height: 60,
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "30px",
        }}>
            <ModalSendMail
                modalOpen={isModalSendOpen}
                setModalOpen={setIsModalSendOpen}
                email={null}
                phone={null}
                message={t("Добрый день!\n\nУ меня возникла проблема с регистрацией/входом на платформу SPEAKID на странице ") + window.location.href + t(". Помогите, пожалуйста, разобраться.")}
                theme={t("Проблема с регистрацией/входом на платформе SPEAKID")}
            />
            
            <div style={{cursor: "pointer"}} onClick={()=>navigate("/auth/login")}><Logo/></div>
            <div
                style={{cursor: "pointer"}}
                onClick={() => {
                    setIsModalSendOpen(true);
                }}
            >
                <Link
                    //href={`mailto:speakid.help@mail.ru?subject=${encodeURIComponent("Проблема с регистрацией на платформе SPEAKID")}&body=${encodeURIComponent("Добрый день!\n\nУ меня возникла проблема с регистрацией на платформе SPEAKID. Помогите, пожалуйста, разобраться.")}`}
                >
                    {t("Помощь")}
                </Link>
            </div>
        </header>
    )
}

export default Header